const translation = {
  en: {
    not: 'not',
    and: 'and',
    or: 'or',
    then: ' then ',
  },
  es: {
    not: 'no',
    and: 'y',
    or: 'o',
    then: ' entonces ',
  },
}
/**
 *
 * @param {String/Array} logic Qlik Alerting logic definition
 * @param {Object} options concat, separator, locale
 */
const parseLogic = (logic, { concat, separator, locale = 'en' } = {}) => {
  const loc = translation[locale]
  try {
    let thisLogic
    if (!Array.isArray(logic)) thisLogic = [logic]
    else thisLogic = logic
    const result = thisLogic.map(each =>
      each
        .replace(/\d+/g, match =>
          // eslint-disable-next-line radix
          (10 + parseInt(match)).toString(20).toUpperCase()
        )
        .replace(/!/g, `${loc.not} `)
        .replace(/and/g, loc.and)
        .replace(/or/g, loc.or)
    )
    if (concat) return result.join(separator || loc.then)
    return result
  } catch (error) {
    throw Error(error)
  }
}

module.exports = parseLogic
